module.exports = __webpack_public_path__ + "img/四川天府新区白鹭幼儿园.932cb2d4.jpg";